module.exports = __webpack_public_path__ + "img/crna-monthly.2e92bb93.png";